import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ConfigService } from 'services/config/config.service';
import * as i0 from "@angular/core";
import * as i1 from "../config/config.service";
import * as i2 from "@angular/common/http";
var NotificationService = /** @class */ (function () {
    function NotificationService(configSvc, http) {
        this.configSvc = configSvc;
        this.http = http;
    }
    // #region Get Notifications Service Call
    NotificationService.prototype.GetNotifications = function (AuthToken, AsRole) {
        return this.http
            .get(this.configSvc.hostAddress +
            "Api/Services/IRIS/GetNotifications?" +
            ("AuthToken=" + (AuthToken || '') + "&CurrentRole=" + (AsRole || '')))
            .pipe(map(function (notices) {
            if (notices) {
                notices.LastLogin = notices.LastLogin ? new Date(notices.LastLogin) : null;
                if (notices.Notifications && !!notices.Notifications.length) {
                    notices.Notifications.forEach(function (n) {
                        if (n.Details && !!n.Details.length) {
                            n.Details.forEach(function (nd) {
                                nd.DateReferred = nd.DateReferred ? new Date(nd.DateReferred) : null;
                            });
                        }
                    });
                }
            }
            return notices;
        }));
    };
    NotificationService.ngInjectableDef = i0.defineInjectable({ factory: function NotificationService_Factory() { return new NotificationService(i0.inject(i1.ConfigService), i0.inject(i2.HttpClient)); }, token: NotificationService, providedIn: "root" });
    return NotificationService;
}());
export { NotificationService };
// #region Custom Classes
// #region Notification Detail
var NotificationDetail = /** @class */ (function () {
    function NotificationDetail() {
    }
    return NotificationDetail;
}());
export { NotificationDetail };
// #endregion
// #region Notification Item
var NotificationItem = /** @class */ (function () {
    function NotificationItem() {
    }
    return NotificationItem;
}());
export { NotificationItem };
// #endregion
// #region Notifications Info
var NotificationsInfo = /** @class */ (function () {
    function NotificationsInfo() {
    }
    return NotificationsInfo;
}());
export { NotificationsInfo };
